export const FeatureReleaseFlags = {
  DashboardPdfExportTourSeen: 'filtersPdfExportTourSeen',
} as const;

export type FeatureReleaseFlag = typeof FeatureReleaseFlags[keyof typeof FeatureReleaseFlags];

export type FeatureReleasesStateUser = {
  filtersPdfExportTourSeen?: boolean;
};

export const INITIAL_FEATURE_RELEASES_STATE_USER: FeatureReleasesStateUser = {
  filtersPdfExportTourSeen: false,
};

export const FEATURE_RELEASE_DATES: Record<FeatureReleaseFlag, Date> = {
  // Update this when the PDF export dropdown tour ships.
  filtersPdfExportTourSeen: new Date('2026-03-30T00:00:00.000Z'),
};
